import FinancialRpaDomainContent from "../components/rpa/FinancialRpaDomainContent";
import ManufacturingRpaDomainContent from "../components/rpa/ManufacturingRpaDomainContent";
import HRRpaDomainContent from "../components/rpa/HRRpaDomainContent";
import HealthcareRpaDomainContent from "../components/rpa/HealthcareRpaDomainContent";
import LogisticsRpaDomainContent from "../components/rpa/LogisticsRpaDomainContent";
import RetailRpaDomainContent from "../components/rpa/RetailRpaDomainContent";
import InsuranceRpaDomainContent from "../components/rpa/InsuranceRpaDomainContent";
import TelecomRpaDomainContent from "../components/rpa/TelecomRpaDomainContent";
import EnergyRpaDomainContent from "../components/rpa/EnergyRpaDomainContent";
import PublicSectorRpaDomainContent from "../components/rpa/PublicSectorRpaDomainContent";
import RealEstateRpaDomainContent from "../components/rpa/RealEstateRpaDomainContent";
import EducationRpaDomainContent from "../components/rpa/EducationRpaDomainContent";
import HospitalityRpaDomainContent from "../components/rpa/HospitalityRpaDomainContent";
import MediaRpaDomainContent from "../components/rpa/MediaRpaDomainContent";
import AgricultureRpaDomainContent from "../components/rpa/AgricultureRpaDomainContent";
import ITServicesRpaDomainContent from "../components/rpa/ITServicesRpaDomainContent";
import AviationRpaDomainContent from "../components/rpa/AviationRpaDomainContent";

export const RPA_DOMAIN_CONTENT = {
  "financial-domain": FinancialRpaDomainContent,
  "manufacturing": ManufacturingRpaDomainContent,
  "hr-domain": HRRpaDomainContent,
  "healthcare-domain": HealthcareRpaDomainContent,
  "logistics-domain": LogisticsRpaDomainContent,
  "retail-domain": RetailRpaDomainContent,
  "insurance-domain": InsuranceRpaDomainContent,
  "telecom-domain": TelecomRpaDomainContent,
  "energy-utilities-domain": EnergyRpaDomainContent,
  "public-sector-government-domain": PublicSectorRpaDomainContent,
  "real-estate-construction-domain": RealEstateRpaDomainContent,
  "education-domain": EducationRpaDomainContent,
  "hospitality-travel-domain": HospitalityRpaDomainContent,
  "media-entertainment-domain": MediaRpaDomainContent,
  "agriculture-food-processing-domain": AgricultureRpaDomainContent,
  "it-technology-services-domain": ITServicesRpaDomainContent,
  "aviation-aerospace-domain": AviationRpaDomainContent,
};

